import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormGroup,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Switch from "react-switch"
import { Offsymbol, OnSymbol } from "util/switchButtonUtil"
// import CustomSelect from "../../components/CustomSelect/customSelect"
// import MultiSelectSort from "components/SortableSelect/SortableSelect"
import _ from "lodash"
import ValidatorForm, { TextField, MultiSelect } from "../ValidatorForm"
import Select from "react-select"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import { LANGUAGES, PERMISSIONS_ARRAY } from "../../constants/uiConstants"
import "./styles.css"
export default class CreateRolesForm extends ErrorBoundComponent {
  state = {
    formData: {},
    appCode: this.props.appCode,
    status:
      this.props && this.props.data && Object.keys(this.props.data).length === 0
        ? true
        : this.props.data.roleStatus === "active"
        ? true
        : false,
    userTypeOptions: [
      //{ label: "Super Admin", value: 1,disabled: this.props.currentUser.userType > 1 },
      // { label: "Admin", value: 2, disabled: this.props.currentUser.userType > 1},
      { label: "Content Manager", value: 3 }, // Create Update Challem, audio and content
      { label: "Moderator", value: 4 }, // Requires permissions to be updated in the users table and same reads to be handled at routes
      { label: "Ads Ops", value: 6 }, // For source Type and sponsor text in challenge and audio
      { label: "Internal Moderator", value: 7 },
    ],
    agency: null,
    customStyles: {
      option: (provided, state) => ({
        ...provided,
        color: "black",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
      }),
    },
  }

  componentDidMount() {
    const { permissionList = [] } = this.props
    const permissionArray = []
    permissionList.map((item, idx) => {
      let label = item.permissionId.split("_").toString()
      let permissionObj = {
        label: label.replaceAll(",", " "),
        value: item.permissionId,
      }
      permissionArray.push(permissionObj)
    })
    this.setState({ permissionArray })
  }

  _handleFieldChange = (val, field) => {
    let formData = this.state.formData
    const valArray = val.map(element => {
      return element.value
    })
    formData[field] = valArray
    this.setState({
      formData,
    })
  }

  _getDefaultValues = (roles, field) => {
    // let applicationsData = applications.filter((item) => item.applicationCode === this.state.appCode);
    // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
    // let rolesArr = !_.isEmpty(filteredApp) ? (filteredApp["roles"] && filteredApp["roles"].length > 0 ?  filteredApp["roles"] : []) : [];
    let array = []
    let roleOrPermissionArr = []
    switch (field) {
      case "permissions":
      case "excludePermission":
        roleOrPermissionArr = this.state.permissionArray
        break
    }
    roleOrPermissionArr.forEach(item => {
      if (roles.includes(item.value)) {
        array.push(item)
      }
    })
    return array
  }

  _form = () => {
    const { permissionList = [] } = this.props

    const filterdPermissions = PERMISSIONS_ARRAY.map(permission => {
      if (
        permission.value === "UPDATE_USER_AGENCY" &&
        !this.props.currentUser?.jotRoles?.includes("SUPER_ADMIN")
      ) {
        return { ...permission, disabled: true }
      } else {
        return permission
      }
    })
    return (
      <React.Fragment>
        <Col>
          <Card>
            <CardTitle className="p-3 pb-0">
              {this.props.formAction === "create"
                ? "Create Role"
                : "Update Role"}
            </CardTitle>
            <CardBody>
              <AvForm onValidSubmit={(e, values) => this._onSubmit(values)}>
                <Row>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="role" className="col-lg-3">
                        Role Name
                      </Label>
                      <AvField
                        name="roleName"
                        type="text"
                        defaultValue={
                          this.props.data && this.props.data.roleName
                        }
                        errorMessage="Provide Role Name"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="jotPermissions">Add Permissions</Label>
                      <Select
                        styles={this.state.customStyles}
                        isMulti={true}
                        onChange={val =>
                          this._handleFieldChange(val, "permissions")
                        }
                        defaultValue={
                          this.props.data &&
                          this.props.data.permissions &&
                          this._getDefaultValues(
                            this.props.data.permissions,
                            "permissions"
                          )
                        }
                        options={this.state.permissionArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col>

                  <Col lg="6">
                    <FormGroup className="mb-2">
                      <Label htmlFor="roleStatus" className="col-lg-4">
                        Status
                      </Label>
                      <Col lg="10">
                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8 mb-2"
                          onColor="#626ed4"
                          onChange={() =>
                            this.setState({ status: !this.state.status })
                          }
                          checked={this.state.status}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end">
                  <Button type="submit" color="primary" className="mx-2">
                    {this.props.formAction === "create" ? "Create" : "Update"}
                  </Button>
                  <Button color="danger" onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }

  _onSubmit = formData => {
    formData.status = this.state.status ? "active" : "inactive"
    const {
      permissions = [],
      excludePermission = [],
      roles = [],
    } = this.state.formData
    const data = new FormData()
    // if (!_.isEmpty(formData.permission)) {
    //     data.append("permissionId", formData.permission)
    // }
    if (!_.isEmpty(permissions)) {
      data.append("permissions", JSON.stringify(permissions))
    }
    data.append("roleStatus", formData.status)
    data.append("roleName", formData.roleName.toUpperCase())
    // if (!_.isEmpty(formData.status)) {
    //   data.append("status", formData.status)
    // }
    // Object.keys(this.state.formData).forEach(key => {
    //   if (
    //     this.state.formData[key] !== undefined &&
    //     this.state.formData[key] !== ""
    //   ) {
    //     data.append(key, this.state.formData[key])
    //   }
    // })
    // var data = _.omitBy(formData, _.isNil)
    // data.includePermission = !_.isEmpty(includePermission)
    //   ? JSON.stringify(includePermission)
    //   : JSON.stringify([])
    // data.excludePermission = !_.isEmpty(excludePermission)
    //   ? JSON.stringify(excludePermission)
    //   : JSON.stringify([])
    this.props.onSubmit(data)
  }

  _render = () => {
    return this._form()
  }
}
